/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { ONLINE_VISA_ROUTES } from '../online-visa/constants/onlineVisaConstants';
import { formatCurrency } from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
// import { useNavigate } from 'react-router-dom';

function VisaBookingListCard({ bookingData }) {
  // const navigate = useNavigate();

  const handleInvoiceClick = () => {
    const url = ONLINE_VISA_ROUTES.INVOICE.replace(
      ':transactionId',
      bookingData.visa_application_id,
    );
    window.open(url, '_blank');
  };

  const handleVoucherClick = () => {
    const url = ONLINE_VISA_ROUTES.BOOKING_DETAILS.replace(
      ':transactionId',
      bookingData.visa_application_id,
    );
    window.open(url, '_blank');
  };

  return (
    <div className="cab-booking-list-card mb-2 p-2">
      <Row>
        <Col xs={12} md={12} lg={9}>
          <Row>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">Visa Name</div>
              <div className="fw-600">{bookingData.visa_name}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Country</div>
              <div className="fw-600">{bookingData.country_to}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Entry Type</div>
              <div className="fw-600">{bookingData.entry}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Processing Time</div>
              <div className="fw-600">{bookingData.processing_time}</div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">Booked On</div>
              <div className="fw-600">
                {bookingData.created_on?.split('.')[0]}
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Adults</div>
              <div className="fw-600">{bookingData.total_adults}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Children</div>
              <div className="fw-600">{bookingData.total_child}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Infants</div>
              <div className="fw-600">{bookingData.total_infants}</div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">Validity</div>
              <div className="fw-600">
                {bookingData.validity} {bookingData.validity_type}
              </div>
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={12} lg={3}>
          <div className="transaction-details">
            <div>
              <span>
                <b>Ref No: </b>
                {bookingData.application_ref_no}
              </span>
            </div>
            <div>
              <span>
                <b>Status: </b>
                {bookingData.booking_status}
              </span>
            </div>
            <div>
              <span>
                <b>Visa Status: </b>
                {bookingData.visastatus}
              </span>
            </div>
            <div>
              <span className="fw-600">
                {formatCurrency(bookingData.total_amount)}
              </span>
            </div>
          </div>
          <div className="mt-2 d-flex gap-2 justify-content-end">
            <AppButton
              btnText="Invoice"
              variant="outlined"
              onClick={handleInvoiceClick}
            />
            <AppButton
              btnText="Voucher"
              variant="secondary"
              onClick={handleVoucherClick}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

VisaBookingListCard.propTypes = {
  bookingData: PropTypes.object.isRequired,
};

export default VisaBookingListCard;
